module.exports = __webpack_public_path__ + "static/nshn-logo-18c38f3905dbd1610c7c0de720d07183.png";